import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import Icon from '../../components/misc/Icons'

// const SECTION_OFFSETS={
// 	maths:810 + 440,
// 	video:1711 + 440,
// 	sound:2594 + 440,
// 	mediaChoices:3381 + 440,
// 	editImages:4146 + 440,
// 	shortcuts:4919 + 440,
// }

const SECTION_SCROLL_TO_OFFSETS={
	maths:740,
	video:1631,
	sound:2506,
	mediaChoices:3307,
	editImages:4084,
	shortcuts:4896
}



// class RichTextMarketingStickyNavTab extends Component {
// 	render() {
// 		return (
// 			<div onClick={this.props.scrollToSection} className={'richTextMarketing-stickyNav-tab ' + (this.props.active ? 'richTextMarketing-stickyNav-tab--active' : 'richTextMarketing-stickyNav-tab--inactive')}>
// 				{this.props.label}
// 			</div>	
// 		)
// 	}
// }

// class RichTextMarketingStickyNav extends Component {
	
// 	render() {
// 		const {activeSection,scrollToSection}=this.props
// 			return (
// 				<div className='richTextMarketing-stickyNavContainer'>
// 					<div className='richTextMarketing-stickyNav'>
// 						<RichTextMarketingStickyNavTab active={activeSection==='maths'} label='Math and Science' scrollToSection={()=>scrollToSection('maths')}/>
// 						<RichTextMarketingStickyNavTab active={activeSection==='video'} label='YouTube Videos' scrollToSection={()=>scrollToSection('video')}/>
// 						<RichTextMarketingStickyNavTab active={activeSection==='sound'} label='Sound Clips' scrollToSection={()=>scrollToSection('sound')}/>
// 						<RichTextMarketingStickyNavTab active={activeSection==='mediaChoices'}label='Media Choices' scrollToSection={()=>scrollToSection('mediaChoices')} />						
// 						<RichTextMarketingStickyNavTab active={activeSection==='editImages'} label='Edit Images' scrollToSection={()=>scrollToSection('editImages')} />
// 						<RichTextMarketingStickyNavTab active={activeSection==='shortcuts'} label='Shortcuts' scrollToSection={()=>scrollToSection('shortcuts')} />					
// 					</div>
// 				</div>
// 			)
// 	}
// }


class RichTextMarketingVideoTab extends Component {
	
	render() {
		const {sectionStartTime,sectionEndTime,videoCurrentTime,seekTo,videoId}=this.props
		const active= videoCurrentTime>sectionStartTime && videoCurrentTime<sectionEndTime 
		let progress=0
		if(active){
			progress=(videoCurrentTime-sectionStartTime)/(sectionEndTime-sectionStartTime)
		}

			return (
				<div onClick={()=>{seekTo(videoId,sectionStartTime)}} className={'richTextMarketing-videoTab ' + (active ? 'richTextMarketing-videoTab--active' : 'richTextMarketing-videoTab--inactive')}>

					<div className='richTextMarketing-videoTab-activeLabel'>
						{this.props.label}
					</div>

					<div className='richTextMarketing-videoTab-inactiveLabel'>
						{this.props.label}
					</div>


					{active && progress &&
						<div className='richTextMarketing-videoTab-progressBar'>
							<div style={{width: `${progress * 100}%`}} className='richTextMarketing-videoTab-progressBar-bar'/>
							<div className='richTextMarketing-videoTab-progressBar-track'/>
						</div>
					}
					
				</div>
			)
	}
}


class RichTextMarketingContent extends Component {


  constructor(props) {
    super(props)
    this.updateVideoCurrentTime=this.updateVideoCurrentTime.bind(this)
    this.seekTo=this.seekTo.bind(this)
    this.handleOnScroll=this.handleOnScroll.bind(this)
    this.handleOnScroll = debounce(this.handleOnScroll,10)	
    this.scrollToSection=this.scrollToSection.bind(this)

    this.timer=null

    this.state = {
      video1CurrentTime:0,
      video2CurrentTime:0,
      video3CurrentTime:0,
      video4CurrentTime:0,
      video5CurrentTime:0,
      activeSection:null
 	   }  
	}	

	componentDidMount(){
		this.startTimer()
		this.video1.playbackRate = 1.3
		this.video2.playbackRate = 1
		this.video4.playbackRate = 1.5
		this.video3.playbackRate = 1.3
		//document.addEventListener('scroll', this.handleOnScroll)
		if(window.innerHeight>700 && this.video1){
			this.video1.play()
		}

	}
	
	componentWillUnmount() {
		this.stopTimer()
	//	document.removeEventListener('scroll', this.handleOnScroll)
	}


	scrollToSection(section){
		const scrollAmount=SECTION_SCROLL_TO_OFFSETS[section]
		window.scrollTo(0,scrollAmount)
		setTimeout(function() {
   			this.setState({activeSection:section})
     	}.bind(this),50)
		
	}	

	handleOnScroll(e){
		const el=document.getElementById('scrollable_container')
		if(el){
			const offset=el.scrollTop + window.innerHeight
			if(offset>727 && this.video1){
				this.video1.play()
			}
			if(offset>1545 && this.video2){
				this.video2.play()
			}
			if(offset>2313 && this.video3){
				this.video3.play()
			}
			if(offset>3685 && this.video4){
				this.video4.play()
			}
			if(offset>4370 && this.video5){
				this.video5.play()
			}
		}
	

	}

	startTimer(){
	    this.timer = setInterval(() => {
	      this.updateVideoCurrentTime()
	    }, 50)
	  }

	  stopTimer(){
	    clearInterval(this.timer)
	    this.timer=null
	  }


	updateVideoCurrentTime(){
		if(this.video1){
			const currentTime=this.video1.currentTime
    	this.setState({video1CurrentTime:currentTime})
		}
		if(this.video2){
			const currentTime=this.video2.currentTime
    	this.setState({video2CurrentTime:currentTime})
		}
		if(this.video3){
			const currentTime=this.video3.currentTime
    	this.setState({video3CurrentTime:currentTime})
		}
		if(this.video4){
			const currentTime=this.video4.currentTime
    	this.setState({video4CurrentTime:currentTime})
		}
		if(this.video5){
			const currentTime=this.video5.currentTime
    	this.setState({video5CurrentTime:currentTime})
		}
  }

  seekTo(videoId,seconds){
  	if(videoId==='video1'){
  		this.video1.currentTime=seconds
  	}
  	if(videoId==='video2'){
  		this.video2.currentTime=seconds
  	}
  	if(videoId==='video3'){
  		this.video3.currentTime=seconds
  	}
  	if(videoId==='video4'){
  		this.video4.currentTime=seconds
  	}
  	if(videoId==='video5'){
  		this.video5.currentTime=seconds
  	}
  }


	render() {

		const modalMode = true		

		const largeSlide = "https://res.cloudinary.com/plickers-static/image/upload/w_1280,f_auto,q_100/"
		const smallSlide = "https://res.cloudinary.com/plickers-static/image/upload/w_1280,f_auto,q_100/"

		const tundraSlide = "v1632315673/richtextmarketing/slides/tundra.png"
		const rainfallSlide = "v1632315670/richtextmarketing/slides/rainfall.png"
		const loroSlide = "v1632315669/richtextmarketing/slides/loro.png"
		const simultaneousSlide = "v1632315667/richtextmarketing/slides/simulataneous.png"
		const qweqSlide = "v1632315665/richtextmarketing/slides/qweq.png"
		const romeoSlide = "v1632315664/richtextmarketing/slides/romeo.png"
		const temperatureSlide = "v1632315664/richtextmarketing/slides/temperature.png"
		const octogonSlide = "v1632315662/richtextmarketing/slides/octogon.png"	
		const exponentsSlide = "v1632315661/richtextmarketing/slides/exponents.png"	


		const megaequationSlide = "v1632315655/richtextmarketing/slides/megaequation.png"		
		
		//const unitedNationsSlide = "v1632315659/richtextmarketing/slides/united_nations.png"		
		const spaceXSlide = "v1632315659/richtextmarketing/slides/spacex.png"		
		
		const trumpetSlide = "v1632315656/richtextmarketing/slides/trumpet.png"	
		
		const equilibriumSlide = "v1632315654/richtextmarketing/slides/equilibirum.png"		
		const mlkSlide = "v1632315660/richtextmarketing/slides/mlk.png"
		//const whaleSlide = "v1632315658/richtextmarketing/slides/whales.png"		
		const sarahAnimalSlide = "v1632315658/richtextmarketing/slides/sarahananimal.png"		


		let userIsFree = false
		let userIsPro = false
		if(this.props.service){
			if(this.props.service.product==='plus'){
				userIsPro=true
			}else{
				userIsFree=true
			}
		}

		const {initialLoad} = this.props
		// const initialLoad = true
		

			return (
						
				<div className='richTextMarketingModalContainer' onScroll={this.handleOnScroll} id={'scrollable_container'}>
					<div className={'richTextMarketing ' + (modalMode ? 'richTextMarketing--modalMode' : 'richTextMarketing--pageMode')}>

						{modalMode &&
							<div onClick={this.props.dismissModal} className='richTextMarketing-closeBtn'>
								<Icon name='close' />
							</div>
						}


						{/* HEADER */}
						{initialLoad &&
						<div className='richTextMarketing-header '>
							<div className='richTextMarketing-header-slideArray'>
								<div className='richTextMarketing-header-slideArray-small'>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${tundraSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${rainfallSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${simultaneousSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${octogonSlide}`} alt=''/>
									</div>									
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${spaceXSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${romeoSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${temperatureSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${exponentsSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${loroSlide}`} alt=''/>
									</div>									
								</div>
								<div className='richTextMarketing-header-slideArray-large'>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${equilibriumSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${megaequationSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${sarahAnimalSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${mlkSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${trumpetSlide}`} alt=''/>
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${qweqSlide}`} alt=''/>
									</div>
								</div>

							</div>

													
							<div className='richTextMarketing-header-text'>
															
								<div className='richTextMarketing-header-text-h2'>
									We joined forces with hundreds of teachers to design, test, and build a major update to Plickers. <span>Here's what's new</span>.
								</div>

								{/*}
								<div className='richTextMarketing-header-text-h1'>
									Here’s the result. Welcome to the all-new Plickers.
								</div>
								<div className='richTextMarketing-header-text-h1'>
									Coming this Sunday. Our biggest update ever.
								</div>
								*/}											

							</div>						

						</div>
						}

						{/*}						
						<RichTextMarketingStickyNav activeSection={this.state.activeSection} scrollToSection={this.scrollToSection}/>
						*/}
						
						{!initialLoad &&
							<div className='richTextMarketing-repeatLoadHeader'>
								What's new
							</div>
						}

						{!initialLoad &&
							<div className='richTextMarketing-repeatLoad-newSection'>								
								<div className='richTextMarketing-repeatLoad-newSection-date'>
									October 26 2021
								</div>
								<div className='richTextMarketing-repeatLoad-newSection-header'>
									Math and Science Extras
								</div>																									
								<div className='richTextMarketing-repeatLoad-newSection-featureContainer'>
									<div className='richTextMarketing-repeatLoad-newSection-newFeature'>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-header'>
											Fast Fractions 
										</div>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-description'>
											Insert fractions easily with the new fast fractions feature! Just type fractions, like 1/2 or 2/3 and hit the spacebar. You can also insert fractions from the toolbar or use the new // shortcut. Fast fractions are also useful to write simple relationships like speed = distance/time.
										</div>										
									</div>
									<div className='richTextMarketing-repeatLoad-newSection-newFeature'>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-header'>
											Tumble Science Podcast for Kids
										</div>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-description'>
											We've partnered with Tumble Media to include episodes from Tumble Science Podcast for Kids teachers. Find the full, ad-free episodes in the Sound Library and try them out in your next lesson!
										</div>										
									</div>
									<div className='richTextMarketing-repeatLoad-newSection-newFeature'>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-header'>
											Advanced Equations
										</div>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-description'>
											Advanced/AP math teachers – you can now enter custom LaTeX syntax to create matrices, widehat, cases, and more. Just click 'Advanced Equation' in the Equation Editor. You can also add a toolbar button for Advanced Equations, or use the $/ shortcut.
										</div>										
									</div>
									<div className='richTextMarketing-repeatLoad-newSection-newFeature'>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-header'>
											Printing Support for Equations
										</div>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-description'>
											All your new equations can now be printed from the Set Editor or for Student Reports!
										</div>										
									</div>
									<div className='richTextMarketing-repeatLoad-newSection-newFeature'>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-header'>
											Advanced Chemistry Equations
										</div>
										<div className='richTextMarketing-repeatLoad-newSection-newFeature-description'>
											Inside Advanced Equations, we’ve added additional Chemistry support for charges, nuclides, isotopes, bonds, and a whole lot more for more complete AP support.
										</div>										
									</div>
									
									


								</div>

							</div>
						}


						{/* MATHS SECTION */}
						<div className='richTextMarketing-sectionContainer richTextMarketing-sectionContainer--math'>													
							<div className='richTextMarketing-section richTextMarketing-section--maths'>
								{initialLoad &&
									<div className='richTextMarketing-section-label'>
										Math and Science
									</div>
								}
								{/*
								{!initialLoad &&
									<div className='richTextMarketing-section-label'>
										What's new
									</div>
								}*/}

								<div className='richTextMarketing-section-h1'>
									Full K-12 Math and Science support.
								</div>

								<div className='richTextMarketing-section-videoTabArray'>
									<RichTextMarketingVideoTab label="Equations" sectionStartTime={0} sectionEndTime={11} videoCurrentTime={this.state.video1CurrentTime} videoId={'video1'} seekTo={this.seekTo}/>									
									<RichTextMarketingVideoTab label="Exponents" sectionStartTime={11} sectionEndTime={29} videoCurrentTime={this.state.video1CurrentTime} videoId={'video1'} seekTo={this.seekTo}/>
									<RichTextMarketingVideoTab label="Subscript" sectionStartTime={29} sectionEndTime={40} videoCurrentTime={this.state.video1CurrentTime} videoId={'video1'} seekTo={this.seekTo}/>
									<RichTextMarketingVideoTab label="Symbols" sectionStartTime={40} sectionEndTime={53} videoCurrentTime={this.state.video1CurrentTime} videoId={'video1'} seekTo={this.seekTo}/>
									<RichTextMarketingVideoTab label="Chemical Compounds" sectionStartTime={53} sectionEndTime={80} videoCurrentTime={this.state.video1CurrentTime} videoId={'video1'} seekTo={this.seekTo}/>
								</div>

								<div className='richTextMarketing-section-videoDevice'>
									<div className='richTextMarketing-section-videoDevice-videoContainer'>
										
										<video ref = {(ref) => { this.video1 = ref }} loop muted preload="auto" className="richTextMarketing-section-videoDevice-video">																					
											<source src="https://assets.plickers.com/react-assets/richtextmarketing/RichTextMarketingScienceAndMath.mp4" type="video/mp4" />											
										</video>
										
									</div>
								</div>
							</div>
						</div>

						{/* MULTIMEDIA SECTION */}
						<div className='richTextMarketing-sectionContainer richTextMarketing-sectionContainer--videos'>							
							<br/>
							<br/>							
							<br/>
							<div className='richTextMarketing-section richTextMarketing-section--maths'>
								<div className='richTextMarketing-section-label'>
									YouTube Videos
								</div>
								<div className='richTextMarketing-section-h1'>
									Bring questions to life with YouTube and GIPHY.
								</div>

								<div className='richTextMarketing-section-videoTabArray'>
									<RichTextMarketingVideoTab label="Insert YouTube Videos" sectionStartTime={0} sectionEndTime={14} videoCurrentTime={this.state.video2CurrentTime} videoId={'video2'} seekTo={this.seekTo}/>									
									<RichTextMarketingVideoTab label="Edit Videos" sectionStartTime={14} sectionEndTime={25} videoCurrentTime={this.state.video2CurrentTime} videoId={'video2'} seekTo={this.seekTo} />									
									<RichTextMarketingVideoTab label="Insert GIPHY" sectionStartTime={25} sectionEndTime={42} videoCurrentTime={this.state.video2CurrentTime} videoId={'video2'} seekTo={this.seekTo}/>
								</div>

								<div className='richTextMarketing-section-videoDevice richTextMarketing-section-videoDevice--video'>
									<div className='richTextMarketing-section-videoDevice-videoContainer'>
										
										<video ref = {(ref) => { this.video2 = ref }} loop muted preload="auto" className="richTextMarketing-section-videoDevice-video">																					
											<source src="https://assets.plickers.com/react-assets/richtextmarketing/RichTextMarketingVideoAndGIF.mp4" type="video/mp4" />
										</video>
										
									</div>
								</div>
							</div>
						</div>

						{/* MULTIMEDIA SECTION */}
						<div className='richTextMarketing-sectionContainer'>
							<br/>														
							<br/>
							<br/>
							<div className='richTextMarketing-section richTextMarketing-section--maths'>
								<div className='richTextMarketing-section-label'>
									Sound Clips
								</div>
								<div className='richTextMarketing-section-h1'>
									Language and music teachers, this one's for you.
								</div>

								<div className='richTextMarketing-section-videoTabArray'>									
									<RichTextMarketingVideoTab label="Record and Upload Audio" sectionStartTime={0} sectionEndTime={30} videoCurrentTime={this.state.video3CurrentTime} videoId={'video3'} seekTo={this.seekTo}/>									
									<RichTextMarketingVideoTab label="Edit Audio" sectionStartTime={30} sectionEndTime={40} videoCurrentTime={this.state.video3CurrentTime} videoId={'video3'} seekTo={this.seekTo}/>
									<RichTextMarketingVideoTab label="Sound Library" sectionStartTime={40} sectionEndTime={58} videoCurrentTime={this.state.video3CurrentTime} videoId={'video3'} seekTo={this.seekTo}/>									
								</div>

								<div className='richTextMarketing-section-videoDevice'>
									<div className='richTextMarketing-section-videoDevice-videoContainer'>
										
										<video ref = {(ref) => { this.video3 = ref }} loop muted preload="auto" class="richTextMarketing-section-videoDevice-video">										
											{/* <source src="https://res.cloudinary.com/plickers-static/video/upload/w_962/q_auto:best/v1599909667/elearningvideos/ELearningLearnMoreStudentBGVideo.B.mp4" type="video/mp4" /> */}											

											<source src="https://assets.plickers.com/react-assets/richtextmarketing/RichTextMarketingSounds.mp4" type="video/mp4" />											
										</video>
										
									</div>
								</div>
							</div>
						</div>

						


						<div className='richTextMarketing-sectionContainer richTextMarketing-sectionContainer--mediaChoices'>
							<br/>							
							<div className='richTextMarketing-section richTextMarketing-section--mediaChoices'>
								<div className='richTextMarketing-section-label'>
									Media Choices
								</div>
								<div className='richTextMarketing-section-h1'>
									Use anything as answer choices.<br/>Images. Sounds. Videos. GIFs. Equations.
								</div>								
								<div className='richTextMarketing-mediaChoice-slide richTextMarketing-mediaChoice-slide--1'>									
									<img src={`${largeSlide}v1632315656/richtextmarketing/slides/trumpet.png`} alt=''/>
								</div>
								{/*}
								<div className='richTextMarketing-mediaChoice-slide richTextMarketing-mediaChoice-slide--2'>
									<img src="https://res.cloudinary.com/plickers-static/image/upload/v1632315662/richtextmarketing/slides/octogon.png" />
								</div>
								*/}
								<div className='richTextMarketing-mediaChoice-slide richTextMarketing-mediaChoice-slide--3'>									
									<img src={`${largeSlide}v1632233756/richtextmarketing/mediachoicesSounds.png`} alt=''/>
								</div>
								<div className='richTextMarketing-mediaChoice-slide richTextMarketing-mediaChoice-slide--4'>																																				
									<img src={`${largeSlide}v1632233227/richtextmarketing/mediachoicesImages.png`} alt=''/>
								</div>
							</div>
						</div>


						{/* REMOTE CONTROL SECTION 
						<div className='richTextMarketing-sectionContainer'>
							<br/>
							<br/>
							<br/>
							<div className='richTextMarketing-section richTextMarketing-section--remoteControl'>
								<div className='richTextMarketing-section-label'>
									Remote Control
								</div>
								<div className='richTextMarketing-section-h1'>
									And in class, control everything with a tap.
								</div>

								<div className='richTextMarketing-section-videoTabArray'>
									<RichTextMarketingVideoTab label="Zoom" sectionStartTime={0} sectionEndTime={54} videoCurrentTime={this.state.video3CurrentTime} videoId={'video3'} seekTo={this.seekTo}/>									
									<RichTextMarketingVideoTab label="Playback" sectionStartTime={54} sectionEndTime={81} videoCurrentTime={this.state.video3CurrentTime} videoId={'video3'} seekTo={this.seekTo}/>									
								</div>

								<div className='richTextMarketing-section-remoteControlVideoContainer'>
									
									<div className='richTextMarketing-section-videoDevice-videoContainer'>										
										<video ref = {(ref) => { this.video3 = ref }} loop autoPlay muted preload="auto" poster="https://res.cloudinary.com/plickers-static/image/upload/w_1280,f_auto,q_100/v1632218191/richtextmarketing/examplemathposter.png" class="richTextMarketing-section-videoDevice-video">																				
											<source src="https://res.cloudinary.com/plickers-static/video/upload/w_1280/q_auto:best/v1632218102/richtextmarketing/ExampleMathVideo.mp4" type="video/mp4" />											
										</video>										
									</div>
									
								</div>
							</div>
						</div>
						*/}


						{/* IMAGES SECTION */}
						<div className='richTextMarketing-sectionContainer richTextMarketing-sectionContainer--images'>
							<div className='richTextMarketing-section richTextMarketing-section--images'>
								<div className='richTextMarketing-section-label'>
									Edit Images and Markup
								</div>
								<div className='richTextMarketing-section-h1'>
									Get images classroom ready, fast.
								</div>

								<div className='richTextMarketing-section-videoTabArray'>
									<RichTextMarketingVideoTab label="Crop and Edit" sectionStartTime={0} sectionEndTime={43} videoCurrentTime={this.state.video4CurrentTime} videoId={'video4'} seekTo={this.seekTo}/>									
									<RichTextMarketingVideoTab label="Markup Images" sectionStartTime={43} sectionEndTime={108} videoCurrentTime={this.state.video4CurrentTime} videoId={'video4'} seekTo={this.seekTo}/>									
								</div>

								<div className='richTextMarketing-section-imageVideoContainer'>									
									<video ref = {(ref) => { this.video4 = ref }} loop muted preload="auto" poster="https://res.cloudinary.com/plickers-static/image/upload/w_1280,f_auto,q_100/v1632305811/richtextmarketing/CropVideoPoster.png" className="richTextMarketing-section-videoDevice-video">										
										<source src="assets.plickers.com/react-assets/richtextmarketing/RichTextMarketingImageEditing.mp4" type="video/mp4" />																						
									</video>									
								</div>
							</div>
						</div>


						<div className='richTextMarketing-sectionContainer richTextMarketing-sectionContainer--shortcuts'>													
							<br/>
							<br/>
							<br/>
							<div className='richTextMarketing-section'>								
								<div className='richTextMarketing-section-h1'>
									{/* Fly through your prep with shortcuts. */}
									Insert symbols instantly with the <span>/</span> key.
								</div>								
								<div className='richTextMarketing-section--shortcut-topContainer'>

									
										<div className='richTextMarketing-section--shortcut-para'>											
											<div className='richTextMarketing-section--shortcut-para-text'>
												<p>
													Use the / key to access the complete symbol list, including foreign characters and math and science symbols.
												</p>
												<p>
													Type to filter or access your most recently-used symbols with the arrow keys. 
												</p>
											</div>
										</div>

									

									<div className='richTextMarketing-section--shortcut-videoContainerContainer'>
										<div className='richTextMarketing-section--shortcut-videoContainer'>										
											<video ref = {(ref) => { this.video5 = ref }} loop muted preload="auto" class="richTextMarketing-section--shortcut-video">																																		
												<source src="https://assets.plickers.com/react-assets/richtextmarketing/RichTextMarketingShortcuts.mp4" type="video/mp4" />																							
											</video>										
										</div>
									</div>									

								</div>
							</div>

								
						</div>
						 

						
						<div className='richTextMarketing-listContainer'>						
							<div className='richTextMarketing-section richTextMarketing-section--list'>								
								<div className='richTextMarketing-section-label'>
									and lots more
								</div>

								<div className='richTextMarketing-section-listColumnContainer'>
									<div className='richTextMarketing-section-listColumn'>
										<ul>
											<li>Paste images from your clipboard.</li>
											<li>Undo and redo.</li>
											<li>Remote-control playback of video and sound clips with the app.</li>
											
											
											{/*<li>To celebrate the new school year, all media searches, uploads, and edits will be unlimited this term.</li> */}
											{/*<li>Plickers Pro teachers have unlimited access.</li>*/}

											
																																	
											<li></li>																																
										</ul>
									</div>
									<div className='richTextMarketing-section-listColumn'>
										<ul>											
											<li>Zoom images in Now Playing.</li>								
											<li>Format text with bold, italics, and highlighting.</li>
											<li>Larger, more readable text sizes.</li>											
										</ul>
									</div>									
									
								</div>

								
							</div>
						</div>

					
					<div className='richTextMarketing-bottomAreaContainer'>
						<div className='richTextMarketing-bottomArea'>

								{initialLoad &&
									<button onClick={this.props.dismissModal} className='richTextMarketing-bottomArea-getStartedBtn'>
										Get Started
									</button>
								}
								{!initialLoad &&
									<button onClick={this.props.dismissModal} className='richTextMarketing-bottomArea-getStartedBtn'>
										Done
									</button>
								}
								
								<div className='richTextMarketing-bottomArea-text'>								
									
									{userIsFree &&
									 	<span>Plickers Free teachers have access to all the new features (some limits may apply).</span>
									}

									{userIsPro &&
											<span>Plickers Pro teachers have unlimited access to all the new features.</span>
									}

									<br/><br/>

									Thank you to all the teachers who worked with us on this release. ❤️
								</div>


								{/*}


								<div className='richTextMarketing-bottomArea-text'>								
									 We can't wait to hear what you all think.
								</div>

								<div className='richTextMarketing-bottomArea-text2'>								
									 Nolan and the Plickers team.
								</div>
								*/}
															
								
							</div>
					</div>
					{/*}
					<div className='richTextMarketing-header-slideArray richTextMarketing-header-slideArray--2'>
								<div className='richTextMarketing-header-slideArray-small'>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${tundraSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${rainfallSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${simultaneousSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${octogonSlide}`} />
									</div>									
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${spaceXSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${romeoSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${temperatureSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${exponentsSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-small-slide'>
										<img src={`${smallSlide}${loroSlide}`} />
									</div>									
								</div>
								<div className='richTextMarketing-header-slideArray-large'>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${equilibriumSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${megaequationSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${sarahAnimalSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${mlkSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${trumpetSlide}`} />
									</div>
									<div className='richTextMarketing-header-slideArray-large-slide'>
										<img src={`${largeSlide}${qweqSlide}`} />
									</div>
								</div>

							</div>					
						*/}
					</div>
					<div onClick={this.props.dismissModal} className='richTextMarketing-bgClick' />
				</div>									
			)
	}
}


export default connect((state) => ({
		service:state.service

	}),{})(RichTextMarketingContent)
